import { render, staticRenderFns } from "./ListGroupCustom.vue?vue&type=template&id=24c317c8&"
import script from "./ListGroupCustom.vue?vue&type=script&lang=js&"
export * from "./ListGroupCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports